import { SVGProps } from 'react';

export const DataAnalysis = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.72222 10.278V0.500244H0.5V11.5002H11.5V10.278H1.72222Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5001 1.72278H9.05566V9.05611H11.5001V1.72278Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.44444 5.38892H6V9.05558H8.44444V5.38892Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.38878 4.16663H2.94434V9.05551H5.38878V4.16663Z"
      fill="currentColor"
    />
  </svg>
);
